//# sourceMappingURL=my-date.interface.js.map


//////////////////
// WEBPACK FOOTER
// ./~/mydaterangepicker/dist/interfaces/my-date.interface.js
// module id = 1009
// module chunks = 3